import { CeoCreditAgreement } from '@revenuemarket/trade';

import { API } from '~apis/axios/instance';
import { ResponseBase } from '~types/response';

export interface GetCeoCreditAgreementResponse extends ResponseBase {
  data: CeoCreditAgreement[];
}

/**
 * USER가 요청한 대표자 신용조회 목록을 조회합니다.
 * @link https://apollo11.dev.clobe.ai/swagger-ui/index.html#/term-request-controller/getCeoCreditRequest
 *
 * @param companyId
 * @param termRequestId
 * @returns
 */
export default function getCeoCreditAgreements(companyId: string, termRequestId: string) {
  return API.get<GetCeoCreditAgreementResponse>(
    `/api/v2/companies/${companyId}/term-requests/${termRequestId}/ceo-credit-agreements`,
  );
}
